import { createContext, FC, ReactNode } from "react";
import { IdentityAttachmentType } from "../../../../../../../store/common/models";

interface IdTypeContext {
  idType?: IdentityAttachmentType;
  setIdType: (d: IdentityAttachmentType | undefined) => void;
}

export const IdTypeContext = createContext<IdTypeContext>(
  (undefined as any) as IdTypeContext
);

export const IdTypeContextProvider: FC<
  IdTypeContext & {
    children: ReactNode;
  }
> = ({ idType, setIdType, children }) => {
  return (
    <IdTypeContext.Provider
      value={{
        idType,
        setIdType,
      }}
    >
      {children}
    </IdTypeContext.Provider>
  );
};
